import React from 'react'
import SEO from "../component/SEO";
import cancelImage from "../images/so.png"

const Cancel = () => {
  return (
    <div className='flex flex-col my-36 items-center justify-center'>
    <SEO title="Payment Cancelled - K Bakery" description="Your payment was cancelled." />
    <h1 className="text-3xl font-bold text-red-600 mb-4">Payment Cancelled</h1>
    <img src={cancelImage} style={{ width: '450px', height: '300px' }} alt="Payment Cancelled"/>
  </div>
  )
}

export default Cancel